/*
 * @Autor: Nehc
 * @Date: 2020-12-18 16:47:13
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-18 17:34:51
 */
import LogView from './table.vue';

export default LogView;
